import styled from 'styled-components';

import Aqua from 'assets/aqua/aqua-logo.svg';

import BlankButton from 'basics/buttons/BlankButton';

import { respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const Container = styled.section`
    position: relative;
    width: 100%;
    height: 54rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: ${COLORS.gray50};

    ${respondDown(Breakpoints.md)`
        height: initial;
        padding: 18rem 0 3.3rem;
    `}
`;

export const PreTitle = styled.div`
    font-size: 1.8rem;
    font-weight: 400;
    line-height: 3.2rem;
    margin-bottom: 2rem;

    ${respondDown(Breakpoints.lg)`
        font-size: 1.6rem;
    `}

    ${respondDown(Breakpoints.md)`
        font-size: 1.4rem;
        line-height: 2.5rem;
        margin-bottom: 0.6rem;
    `}
`;

export const Title = styled.div`
    display: flex;
    align-items: center;
    font-size: 8rem;
    font-weight: 700;
    line-height: 9.4rem;

    ${respondDown(Breakpoints.lg)`
        font-size: 6rem;
    `}

    ${respondDown(Breakpoints.md)`
        display: flex;
        flex-direction: column;
        font-size: 2.4rem;
        line-height: 2.8rem;
    `}
`;

export const AquaLogo = styled(Aqua)`
    width: 5.4rem;
    height: 5.4rem;
    margin-right: 1.6rem;
    flex-shrink: 0;

    ${respondDown(Breakpoints.md)`
        margin-bottom: 4.7rem;
        margin-right: 0;
        margin-top: -9.8rem;
    `}
`;

export const Value = styled.div`
    display: flex;
    align-items: center;
    min-height: 9.4rem;

    ${respondDown(Breakpoints.md)`min-height: 2.8rem;`}
`;

export const Retry = styled(BlankButton)`
    color: ${COLORS.purple500};
    font: inherit;
    text-decoration: underline;
`;

export const Description = styled.div`
    font-size: 1.8rem;
    font-style: normal;
    font-weight: 400;
    line-height: 3.2rem;
    text-align: center;
    max-width: 80rem;
    margin-top: 3.2rem;
    color: ${COLORS.textDark};

    ${respondDown(Breakpoints.lg)`
        max-width: 58rem;
        margin-top: 2rem;
        font-size: 1.4rem;
        line-height: 2.7rem;
    `}

    ${respondDown(Breakpoints.md)`
        margin: 2rem 0;
        padding: 0 1.5rem;
        line-height: 2.5rem;
    `}
`;
